export default "__VITE_ASSET__CqFAqDQQ__"